<div id="content-wrapper" class="container">
	<div class="row align-items-center" style="height:calc(100vh - 166px);">
		<div class="col">

			<div class="row justify-content-center">
				<div class="col-auto">
					<div class="card shadow">
						<h5 class="card-header">Bejelentkezés</h5>
						<div class="card-body container-fluid" style="width:500px; max-width:calc(100vw - 40px);">
							<%- include('/ui/form', {
								params: [ 'login', login_credentials, { width: 360 } ],
								fields: [
									{ type: 'row', fields: [
										{ type: 'col', fields: [
											{
												type: 'text',
												name: 'account_name',
												title: 'Fiók azonosító',
												attributes: {
													onkeypress: 'Anvil.page.name_keypress(event)'
												}
											},
											{
												type: 'text',
												variant: 'password',
												title: 'Jelszó',
												name: 'password',
												attributes: {
													onkeypress: 'Anvil.page.pw_keypress(event)'
												},
												append: `<button type="button" class="btn btn-outline-secondary" onmousedown="$('#login_password')[0].type = 'text'" onmouseup="$('#login_password')[0].type = 'password'"><i class="fa fa-eye"></i></button>`
											},
											{ type: 'checkbox', name: 'remember_me', title: '', description: 'Azonosító megjegyzése' }
										]}
									]}
								]
							}) %>
						</div>
						<div class="card-footer">
							<div class="float-end">
								<a href="/register" class="btn btn-dark"><i class="fa fa-id-badge me-2"></i>Regisztráció</a>
								<button type="button" onclick="Anvil.page.login()" class="btn btn-primary"><i class="fas fa-sign-in-alt me-2"></i>Belépés</button>
							</div>

							<!--<a href="/forgotten-password" class="btn btn-light"><i class="fas fa-key me-2"></i>Elfelejtett jelszó</a>-->
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>

<script>
Object.assign(Anvil.page, {

	name_keypress: (event) => {
		if (event.key == 'Enter') {
			$('#login_password').focus().select()
		}
	},

	pw_keypress: (event) => {
		if (event.key == 'Enter') {
			Anvil.page.login()
		}
	},

	login: async function () {
		Anvil.exec('auth/action_login', Anvil.models.components.Form.find('#login_form').data)
	}
})

if ($('#login_account_name').val().length == 0) {
	$('#login_account_name').focus()
} else {
	$('#login_password').focus()
}
</script>
